import React from "react";
import { Select } from "antd";
import useSharedStore from "../../stores/sharedStore";

const { Option } = Select;
const FunctionDropdown = (props) => {
  const centralFunctions = useSharedStore((state) => state.centralFunctions);
  return (
    <Select
      {...props}
      id="centralFunctionSelect"
      style={{ width: "72vw", maxWidth: "450px" }}
      value={props.value || ""}
      getPopupContainer={(triggerNode) => triggerNode}
    >
      <Option disabled hidden value="">
        <span style={{ color: "#727272" }}>Select function</span>
      </Option>
      {centralFunctions &&
        centralFunctions.sort().map((value, index) => (
          <Option
            key={index}
            value={value}
            style={{ color: "#37519d", border: "0.25px solid #727272" }}
          >
            {value}
          </Option>
        ))}
    </Select>
  );
};

export default FunctionDropdown;
